import React from "react";

const EditOverview = ({
  width = 14,
  height = 15,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50101 10.6503H2.27344V8.42271L8.27681 2.41934C8.37527 2.32092 8.50878 2.26562 8.64799 2.26562C8.7872 2.26562 8.92071 2.32092 9.01916 2.41934L10.5044 3.90456C10.6028 4.00302 10.6581 4.13653 10.6581 4.27574C10.6581 4.41495 10.6028 4.54846 10.5044 4.64691L4.50101 10.6503ZM2.27344 11.7003H11.7234V12.7503H2.27344V11.7003Z"
        fill="#133345"
      />
    </svg>
  );
};

export default EditOverview;
